export enum EventName {
  Exception = 'exception',
  PaymentFlowComplete = 'payment_flow_complete',
  PaymentFlowCanceled = 'payment_flow_canceled',
  PaymentFlowDispute = 'payment_flow_dispute',
  GatewayOpened = 'gateway_opened',
  GatewayClosed = 'gateway_closed',
  GatewayLoaded = 'gateway_loaded',
  LoginFailed = 'login_failed',
  OpenPaymentMethodSelection = 'open_payment_method_selection',
  NoPaymentMethodsShown = 'no_payment_methods_shown',
  SelectPaymentType = 'select_payment_type',
  RequisitesFound = 'requisites_found',
  RequisitesNotFound = 'requisites_not_found',
  OpenCustomerDataForm = 'open_customer_data_form',
  CustomerPhoneEntered = 'customer_phone_entered',
  CustomerBankSelected = 'customer_bank_selected',
  CustomerNameEntered = 'customer_name_entered',
  TelegramHelp = 'telegram_help',
  TelegramUploadReceipt = 'telegram_upload_receipt',
  OrderCancel = 'order_cancel',
  ConfirmCustomerDetails = 'confirm_customer_details',
  ConfirmTransfer = 'confirm_transfer',
  BackToShop = 'back_to_shop',
  SaveQr = 'save_qr',
  DeeplinkOpen = 'deeplink_open',
  SelectAlternativeAmount = 'select_alternative_amount',
  ResetTradeMethod = 'reset_trade_method',
  ShowAlternativesModal = 'show_alternatives_modal',
  ReceiptUpload = 'receipt_upload',
  ReceiptUploadError = 'receipt_upload_error',
  DismissAlternativesModal = 'dismiss_alternatives_modal',
  CancelSurveyDismiss = 'cancel_survey_dismiss',
  CancelSurveyConfirm = 'cancel_survey_confirm',
}
